import { Tabs, router } from "expo-router";
import React from "react";
import { Platform, Image } from "react-native";
import { IconSymbol } from "@/components/ui/IconSymbol";
import TabBarBackground from "@/components/ui/TabBarBackground";
import { Colors } from "@/constants/ThemeColours";
import { useColorScheme } from "@/hooks/useColorScheme";
import { getRules } from "common247";
import { useAuth } from "@components/auth/useAuth";

const STACK_TAB_NAMES = new Set([
  "my-memories",
  "my-media",
  "my-contacts",
  "my-groups",
  "my-places",
  "my-anchors",
  "my-shares",
  "my-activity",
  "messages",
  "admin",
]);

export default function TabLayout() {
  const { user } = useAuth(true);
  const scheme = useColorScheme();
  const colors = Colors[scheme === "light" ? 'light' : scheme];
  if (user === undefined) return null;
  const rules = getRules();
  const isAdmin = rules.isAdmin.can(user.claims, undefined);
  console.log("user, isAdmin", user, user.claims, isAdmin);

  return (
    <Tabs
      backBehavior="history"
      screenListeners={({ navigation, route }) => ({
        tabPress: (e) => {
          e.preventDefault();
          try {
            if (navigation.isFocused() && router.canDismiss?.()) {
              router.dismissAll?.();
            }
          } catch {
            // Safe fallback if dismissing active stack is not applicable
          }

          if (STACK_TAB_NAMES.has(route.name)) {
            navigation.navigate(route.name, { screen: "index" });
          } else {
            navigation.navigate(route.name);
          }
        },
      })}
      screenOptions={{
        headerShown: false,
        //tabBarButton: HapticTab,
        tabBarActiveTintColor: colors.tint,
        tabBarInactiveTintColor: colors.tintInactive,
        tabBarBackground: TabBarBackground,
        tabBarStyle: Platform.select({
          ios: {
            // Use a transparent background on iOS to show the blur effect
            position: "absolute",
          },
          default: {
            backgroundColor: colors.background,
            borderTopColor: colors.border,
          },
        }),
      }}>

      <Tabs.Screen
        name="index"
        options={{
          title: 'Home',
          tabBarIcon: ({ color, focused }) => (
            <Image
              source={require('@/assets/images/tabIcons/home.png')}
              tintColor={color}
              style={{
                width: 24,
                height: 24,
                opacity: focused ? 1 : 0.6,
              }}
              resizeMode="contain"
            />
          ),
        }}
      />

      <Tabs.Screen
        name="my-memories"
        options={{
          title: "My Memories",
          tabBarIcon: ({ color, focused }) => (<IconSymbol size={28} name="book.closed.fill" color={color}
            style={{
              // tintColor: color,
              opacity: focused ? 1 : 0.6,
            }}
          //resizeMode="contain"
          />
          )
        }}
      />
      <Tabs.Screen
        name="my-media"
        options={{
          title: "My Media",
          tabBarIcon: ({ color, focused }) => (<IconSymbol size={28} name="photo.stack.fill" color={color}
            style={{
              // tintColor: color,
              opacity: focused ? 1 : 0.6,
            }}
          //resizeMode="contain"
          />
          )
        }}
      />
      <Tabs.Screen
        name="my-contacts"
        options={{
          title: "My Contacts",
          tabBarIcon: ({ color, focused }) => (<IconSymbol size={28} name="person.fill" color={color}
            style={{
              // tintColor: color,
              opacity: focused ? 1 : 0.6,
            }}
          //resizeMode="contain"
          />
          )
        }}
      />
      <Tabs.Screen
        name="my-groups"
        options={{
          title: "My Groups",
          tabBarIcon: ({ color, focused }) => (<IconSymbol size={28} name="person.3.fill" color={color}
            style={{
              // tintColor: color,
              opacity: focused ? 1 : 0.6,
            }}
          //resizeMode="contain"
          />
          )
        }}
      />
      <Tabs.Screen
        name="my-places"
        options={{
          title: "My Places",
          tabBarIcon: ({ color, focused }) => (
            <IconSymbol
              size={28}
              name="location.fill"
              color={color}
              style={{
                opacity: focused ? 1 : 0.6,
              }}
            />
          ),
        }}
      />
      <Tabs.Screen
        name="my-anchors"
        options={{
          title: "My Anchors",
          tabBarIcon: ({ color, focused }) => (<IconSymbol size={28} name="anchor" color={color}
            style={{
              // tintColor: color,
              opacity: focused ? 1 : 0.6,
            }}
          //resizeMode="contain"
          />
          )
        }}
      />
      <Tabs.Screen
        name="my-shares"
        options={{
          title: "My Shares",
          tabBarIcon: ({ color, focused }) => (<IconSymbol size={28} name="share.fill" color={color}
            style={{
              // tintColor: color,
              opacity: focused ? 1 : 0.6,
            }}
          //resizeMode="contain"
          />
          )
        }}
      />

      <Tabs.Screen
        name="my-activity"
        options={{
          title: "My Activity",
          tabBarIcon: ({ color, focused }) => (
            <IconSymbol
              size={28}
              name="clock.fill"
              color={color}
              style={{
                opacity: focused ? 1 : 0.6,
              }}
            />
          ),
        }}
      />

      <Tabs.Screen
        name="messages"
        options={{
          href: null,
        }}
      />

      <Tabs.Screen
        name="profile"
        options={{
          href: null,
        }}
      />

      <Tabs.Protected guard={isAdmin}>
        <Tabs.Screen
          name="admin"
          options={{
            title: "Admin",
            tabBarIcon: ({ color, focused }) => (<IconSymbol size={28} name="gear" color={color}
              style={{
                // tintColor: color,
                opacity: focused ? 1 : 0.6,
              }}
            //resizeMode="contain"
            />
            )
          }}
        />
      </Tabs.Protected>
    </Tabs>

  );
}
